module.exports = __webpack_public_path__ + "img/powerplant.da34663.jpg";